import initialUsersState from '../constants/initial-state-parts/initialUsersState';

const usersReducer = (state = initialUsersState, action) => {
  switch (action.type) {
    case 'UPDATE_USERS_LIST':
      return Object.assign({}, state, {
        users: action.newUsersList,
      });
    default:
      return state;
  }
};

export default usersReducer;
